export default __webpack_public_path__ + "static/island-life-banner-696361889a2914d1dd287a0ef2235099.webp";